import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Button } from '../../../components/common/atom/Button';
import { Flex } from '../../../components/common/atom/Layout';
import { Text } from '../../../components/common/atom/Text';
import { CLEARFACE_DETAIL_MENU } from '../../../components/common/organism/Drawer';
import {
  PDPTemplate,
  QUESTION,
  STORY,
} from '../../../components/common/template/PDPTemplate';

import { babyface } from '../../../lib/image/CDNUrl';
import * as PATH from '../../../lib/routes/path';
import { breakpoint } from '../../../lib/style/ThemeStyle';
import ModalContext from '../../../modules/contexts/Modalcontext';
import styled from 'styled-components';

const imageNotFound = '❌';
const dir = '/service';

const Clearface_FAQ_PC = babyface.concat(dir, '/clearface-FAQ-pc-01.png');

const ClearfaceItemImage = babyface.concat(dir, '/clearface-sales.gif');
const ClearfaceProductImg01 = babyface.concat(dir, '/clearface_01.jpg');
const ClearfaceProductImg02 = babyface.concat(dir, '/clearface_02.jpg');
const ClearfaceProductGif01 = babyface.concat(
  dir,
  '/clearface-conversion02.gif',
);
const ClearfaceBanner = babyface.concat(dir, '/clearface_banner.png');

export const faqUrl =
  'https://www.notion.so/FAQ-2-f84458906a7349b9b6319e638dab76b8';

const ClearfaceView = () => {
  const history = useHistory();
  const { onModal } = useContext(ModalContext).actions;

  const showModal = () => {
    onModal({
      title: 'ClearFace가 더욱 강력해졌습니다! 🎉',
      content: <ModalText>
        <p>안녕하세요, ClearFace를 사랑해주시는 고객님들께 기쁜 소식을 전해드립니다.</p>
        <p>ClearFace가 더욱 뛰어난 성능의 'ClearFace Pro (HE)'로 업그레이드되어 전국 산부인과에 도입되고 있습니다. 새로운 버전은 기존보다 더욱 선명하고 정확한 초음파 영상을 제공합니다.</p>
        <p><b>서비스 이용 안내</b></p>
        <ul>
          <li>2024년 11월 부터 ClearFace Pro (HE)는 제휴 병원을 통해서만 이용하실 수 있습니다.</li>
          <li>기존 온라인 서비스는 2024년 10월까지 운영됩니다.</li>
        </ul>
        <p><b>내 병원에서 ClearFace Pro를 만나려면?</b></p>
        <ul>
          <li>담당 산부인과에 ClearFace Pro (HE) 서비스 가능 여부를 문의해주세요.</li>
          <li>아직 도입되지 않은 병원이라면, 병원 담당자께서 베이비페이스 카카오톡 고객센터로 연락주시면 상세한 안내를 도와드리겠습니다.</li>
        </ul>
        <p>더욱 선명하고 감동적인 순간을 선사할 ClearFace Pro (HE)를 곧 만나보세요!</p>
      </ModalText>,
    });
  }

  useEffect(showModal, []);

  return (
    <PDPTemplate
      tabList={[STORY, QUESTION]}
      tabContent={{
        qnaTab: QNA,
      }}
      productInfo={{
        title: '클리어페이스 (ClearFace)',
        instruction: '뱃속에 있는 아기들은 기대어 있거나, 태반, 탯줄 등에 가려져 있어 얼굴 사진을 얻기 어렵습니다. 클리어페이스는, 가려진 얼굴과 해상도가 낮게 나온 입체초음파 사진들을 업그레이드 해드립니다.',
        activeCampaigns: [{ description: '' }],
        eventPrice: 0,
        price: 15000,
        shippingFee: 0,
      }}
      thumbnailImageList={[{ src: ClearfaceItemImage, alt: imageNotFound }]}
      deliveryInfo={
        <Flex justifyContent="flex-start" padding="1.25rem">
          <Text color="orangePink" size={12}>
            25주 이상
          </Text>
          <Text size={12}>의 입체초음파 사진이 필요합니다.</Text>
        </Flex>
      }
      bannerList={[
        {
          src: ClearfaceBanner,
          alt: imageNotFound,
          path: PATH.SALES,
        },
      ]}
    >
      <Flex column id={STORY}>
        <img src={ClearfaceProductImg01} alt={imageNotFound} width="100%" />
        <img src={ClearfaceProductGif01} alt={imageNotFound} width="65%" />
        <img src={ClearfaceProductImg02} alt={imageNotFound} width="100%" />
      </Flex>
      <Flex
        padding="0.625rem"
        width="100%"
        style={{
          position: 'fixed',
          zIndex: 10,
          bottom: 0,
          maxWidth: `${breakpoint}px`,
          background: '#ffffff',
          boxShadow: '0 -3px 6px 0 rgb(0 0 0 / 16%)',
        }}
      >
        <Button onClick={showModal} color='pinkishGrey'>
          신청하기
        </Button>
      </Flex>
    </PDPTemplate>
  );
};

export default ClearfaceView;

const QNA = [
  {
    question: '클리어페이스 신청 시 참고해주세요 (클릭) 🙇🏻',
    answer: `<a href=${faqUrl} target="_blank" rel="noopener noreferrer">
        <img src=${Clearface_FAQ_PC} width="100%" />
      </a>`,
  },
];

const ModalText = styled(Text)`
  font-size: 0.8rem;
  line-height: 1.5;
  white-space: pre-line;

  p {
    margin-bottom: 0;
    font-size: 0.8rem;
    line-height: 1.5;
    white-space: pre-line;
  }

  ul li {
    font-size: 0.8rem;
    line-height: 1.5;
    white-space: pre-line;
  }
`;